angular.module("dx.webapp.library", [
	"digiexam.components",
	"digiexam.exam",
	"digiexam.gradingMatrix",
	"digiexam.services",
	"digiexam.services.faults",
	"dx.webapp.api",
	"dx.webapp.lti",
	"dx.webapp.navigation",
	"dx.webapp.session",

	"dx.ui.components.dialog",
	"dx.ui.components.localize",

	"LocalStorageModule",
	"ngSanitize",
]);
